import get from 'lodash.get';
import getHelpCenterConfig from './help-center-config';

const getGettingStartedUrl = (rootState) => {
  const helpCenterConfig = getHelpCenterConfig(rootState);

  return get(helpCenterConfig, 'getting_started_url', null);
};

export default getGettingStartedUrl;
